import { TQuarter } from './models'

export const quarters: TQuarter[] = ['Q1', 'Q2', 'Q3', 'Q4']

export const businessTypes = ['Renewal', 'New Business']
